import { Component, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, } from "@angular/material/dialog";
import { CONFIG } from "src/app/configuration/app-config";
import { ACTIVITY_TYPE } from "src/app/library/constants/activity";
import { DIFFICULTY } from "src/app/library/constants/difficulty";
import { BasicObject } from "src/app/library/interfaces/general/BasicObject";
import { HttpService } from "src/app/services/networking/rest.service";
import { UialertsService } from "src/app/services/ui/ui-alerts.service";

@Component({
    selector: 'create-activity-dialog',
    templateUrl: 'create-activity-dialog.html',
  })
  export class CreateActivityDialog {
    
    form1 : FormGroup;

    activities : Array<BasicObject> = ACTIVITY_TYPE;
    difficulty_type : Array<BasicObject> = DIFFICULTY;

    loading : boolean = false;

    constructor(private formBuilder : FormBuilder, private http: HttpService, private uiService : UialertsService, @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit() {
      this.form1 = this.formBuilder.group({
        name            : new FormControl(null,[Validators.required]),
        description     : new FormControl(null,[Validators.required]),
        activity        : new FormControl(null,[Validators.required]),
        difficulty      : new FormControl(null,[Validators.required]),
        distanceKM      : new FormControl(null),
        elevationMeters : new FormControl(null),
        durationMinutes : new FormControl(null),
        latitude        : new FormControl(null),
        longitude       : new FormControl(null),
      });
    }

    public async createActivity() { 
      try {

        this.loading = true;

        let formValue = this.form1.getRawValue();

        formValue['coordinates'] = {
          latitude  : formValue.latitude,
          longitude : formValue.longitude
        }

        // await this.http.post(`${CONFIG.API.ADMIN.url}/site/${this.data.siteId}/activity`, formValue);

        this.uiService.openSnackBar({
          duration : 3,
          message : "Activity created",
          mode : "success"
        });

        this.loading = false;
      } catch (error) {
        this.uiService.openSnackBar({
          duration : 3,
          message : "Failed to create activity",
          mode : "danger"
        });

        this.loading = false;
      }
    }
  }
  